<mat-card>
  <mat-card-title>
    {{
      '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.CONFIRM.TITLE'
        | translate
    }}</mat-card-title
  >
  <mat-card-content>
    <div class="content__body">
      <app-banner>
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.CONFIRM.MESSAGE'
              | translate
          }}
        </p>
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.CONFIRM.MINIMUM_LEVEL'
              | translate
          }}
        </p>
        <p>
          {{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.AUTOMATED_MODE_LEVEL_SETTINGS.CONFIRM.MAXIMUM_LEVEL'
              | translate
          }}
        </p>
      </app-banner>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      mat-stroked-button
      gtm="onCancelDialog"
      gtmAction="Cancel"
      gtmCategory="resetToDefaultConfirmModal"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      gtm="onSave"
      gtmAction="Save"
      gtmCategory="resetToDefaultConfirmModal"
      color="primary"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.RESET' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
